import React from 'react';
import CaspianDatePicker from './BaseInputs/CaspianDatePicker';
import fieldworkPeriodDateHelper from '../../Helpers/fieldworkPeriodDateHelper';

// Bravo all-12 fieldwork period editor (MultiEdit wizard, FieldworkPeriodDateTable
// input type). value: [{apply, startDate, endDate}]. Replaces the legacy
// FieldworkPeriodTable; the adjustDates cascade behavior is unchanged.
function FieldworkPeriodDateGrid({ value, editedItem, onChange }) {
  const periods = value ?? [];

  const toggleRow = (index, checked) =>
    onChange(periods.map((period, i) => (i === index ? { ...period, apply: checked } : period)));

  const changeDate = (index, type, newDate) => {
    const startDates = periods.map((period) => period.startDate);
    const endDates = periods.map((period) => period.endDate);
    if (type === 'StartDate') {
      startDates[index] = newDate;
    } else {
      endDates[index] = newDate;
    }
    const timespan = editedItem && editedItem.TimeSpan ? editedItem.TimeSpan : 'other';
    fieldworkPeriodDateHelper.adjustDates(startDates, endDates, index, type, timespan);
    onChange(periods.map((period, i) => ({ ...period, startDate: startDates[i], endDate: endDates[i] })));
  };

  return (
    <div className='bravo-ds mie-host'>
      <div className='fwp-grid'>
        <div className='fwp-row fwp-head'>
          <span className='us-section-lbl'>Fieldwork period</span>
          <span className='us-section-lbl'>Apply</span>
          <span className='us-section-lbl'>Start date</span>
          <span className='us-section-lbl'>End date</span>
        </div>
        {periods.map((period, index) => (
          <div
            className={period.apply ? 'fwp-row' : 'fwp-row off'}
            key={`periodRow${index}`}
          >
            <span className='fwp-name'>Period {index + 1}</span>
            <label className='toggle-field'>
              <span className='fwp-cell-lbl'>Apply</span>
              <span className='switch'>
                <input
                  type='checkbox'
                  checked={period.apply}
                  onChange={(e) => toggleRow(index, e.target.checked)}
                />
                <span className='track' />
                <span className='thumb' />
              </span>
            </label>
            <div className={period.apply ? 'fwp-date' : 'fwp-date off'}>
              <span className='fwp-cell-lbl'>Start date</span>
              <CaspianDatePicker
                selected={period.startDate}
                labelText=''
                disabled={!period.apply}
                onChange={(date) => changeDate(index, 'StartDate', date)}
              />
            </div>
            <div className={period.apply ? 'fwp-date' : 'fwp-date off'}>
              <span className='fwp-cell-lbl'>End date</span>
              <CaspianDatePicker
                selected={period.endDate}
                labelText=''
                disabled={!period.apply}
                onChange={(date) => changeDate(index, 'EndDate', date)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FieldworkPeriodDateGrid;
